// extracted by mini-css-extract-plugin
export var rightPaneBox = "RightPaneBox-module__rightPaneBox___ozaPy";